import {Component} from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError() {
    return {hasError: true};
  }

  componentDidCatch(error) {
    console.error('Page render error:', error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <section className="page-hero">
          <div>
            <span className="eyebrow">Something went wrong</span>
            <h1>Let's try that again.</h1>
            <p>
              <button
                type="button"
                className="primary-button"
                onClick={() => window.location.reload()}
              >
                Reload page
              </button>
            </p>
          </div>
        </section>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;